// src/components/Header.js
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [hidden, setHidden] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const headerRef = useRef(null);

  // Mark pages that include the public header so global spacing can be applied only there
  useEffect(() => {
    document.body.classList.add('site-has-header');
    return () => {
      document.body.classList.remove('site-has-header');
    };
  }, []);

  // Compute the header's bottom edge to create an accurate content offset
  useEffect(() => {
    const updateHeaderOffset = () => {
      if (!headerRef.current) return;
      const rect = headerRef.current.getBoundingClientRect();
      const offset = Math.ceil(rect.bottom);
      document.documentElement.style.setProperty('--header-offset', `${offset}px`);
    };

    updateHeaderOffset();
    window.addEventListener('resize', updateHeaderOffset);
    return () => window.removeEventListener('resize', updateHeaderOffset);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setHidden(true);
      } else {
        setHidden(false);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <>
      <header
        id="site-header"
        ref={headerRef}
        className={`fixed top-4 left-1/2 transform -translate-x-1/2 z-50 transition-all duration-200
        ${hidden ? '-translate-y-full opacity-0' : 'translate-y-0 opacity-100'}`}
      >
      <div className="w-[320px] sm:w-[350px] md:w-[450px] h-[50px] md:h-[60px] bg-[#212121] border border-[#4d4d4d] rounded-full flex items-center justify-around px-2 md:px-0">
        <Link to="/" className="text-sm md:text-base text-gray-300 hover:text-white whitespace-nowrap">Home</Link>
        <a href="/#work" className="text-sm md:text-base text-gray-300 hover:text-white whitespace-nowrap">Work</a>
        <Link to="/about" className="text-sm md:text-base text-gray-300 hover:text-white whitespace-nowrap">About</Link>
        <Link to="/blog" className="text-sm md:text-base text-gray-300 hover:text-white whitespace-nowrap">Blog</Link>
        <Link to="/contact" className="text-sm md:text-base text-gray-300 hover:text-white whitespace-nowrap">Contact</Link>
      </div>
      </header>
    </>
  );
};

export default Header;